<template>
<div class="page-container">
  <el-breadcrumb>
    <el-breadcrumb-item>空投设置</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div class="page-actions">
      <div :style="{flex: 1}">
        <create @refresh="getList"></create>
      </div>
      
    </div>
     <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="所有" name="all"></el-tab-pane>
        <el-tab-pane v-for="(type, key) in statusTypes" :key="key" :label="type.text" :name="key"></el-tab-pane>
      </el-tabs>
    <list @refresh="getList"></list>
  </el-card>
</div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import List from './components/list';
import Create from './components/create';
import { STATUS_TYPE } from './constants';

export default {
  name: 'airdrop',
  data() {
    return {
      statusTypes: STATUS_TYPE
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('airdrop', ['pagination', 'activeTab', 'rootSwitch']),
    ...mapGetters('airdrop', ['list']),
  },
  methods: {
    ...mapActions('airdrop', ['reqList']),
    ...mapMutations('airdrop', ['changeTab']),
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({
        page: 1
      });
    },

    getList(data = {}) {
      this.reqList({
        taskStatus: this.activeTab === 'all' ? '' : this.activeTab,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
.fr {
  float: right;
}
</style>
